// Map Styles
export const stateLine = {
    "id": "stateLines",
    "source": "counties",
    "type": "line",
    "minzoom": 0,
    "maxzoom": 22,
    "layout": {
        "visibility": "visible"
    },
    "paint": {
        "line-blur": 1,
        "line-color": "#232C60",
        "line-width": 2,
        "line-opacity": 1
    }
};
export const stateFill = {
    "id": "stateFills",
    "type": "fill",
    "source": "counties",
    "paint": {
        "fill-color": [
            "interpolate",
            ["linear"],
            ["zoom"],
            0,
            "hsla(231, 47%, 26%, 1)",
            7,
            "hsla(231, 47%, 26%, 0.9)",
            15,
            "hsla(231, 47%, 26%, 0.8)",
            20,
            "hsla(231, 47%, 26%, 0.3)"
        ],
        "fill-opacity": 1,
    }
};
export const countyLine = {
    "id": "countyLines",
    "source": "counties",
    "type": "line",
    "minzoom": 0,
    "maxzoom": 22,
    "layout": {
        "visibility": "visible"
    },
    "paint": {
        "line-blur": 1,
        "line-color": "#232C60",
        "line-width": 2,
        "line-opacity": 1
    }
};
export const countyFill = {
    "id": "countyFills",
    "type": "fill",
    "source": "counties",
    "paint": {
        "fill-color": [
            "interpolate",
            ["linear"],
            ["zoom"],
            0,
            "hsla(231, 47%, 26%, 1)",
            7,
            "hsla(231, 47%, 26%, 0.9)",
            15,
            "hsla(231, 47%, 26%, 0.8)",
            20,
            "hsla(231, 47%, 26%, 0.3)"
        ],
        "fill-opacity": 1,
    }
};
export const countyHover = {
    "id": "countyHover",
    "type": "fill",
    "source": "counties",
    "paint": {
        "fill-color": "#232C60",
        "fill-opacity": 0.8,
    }
};
export const cityLine = {
    "id": "cityLines",
    "source": "cities",
    "type": "line",
    "minzoom": 0,
    "maxzoom": 22,
    "layout": {
        "visibility": "visible"
    },
    "paint": {
        "line-blur": 1,
        "line-color": "#232C60",
        "line-width": 2,
        "line-opacity": 1
    }
};
export const cityFill = {
    "id": "cityFills",
    "type": "fill",
    "source": "cities",
    "paint": {
        "fill-color": "#232C60",
        "fill-opacity": [
            "interpolate",
            ["linear"],
            ["zoom"],
            8,
            0.8,
            15,
            0.75
        ],
    }
};
export const citySelected = {
    "id": "citySelectedFills",
    "type": "fill",
    "source": "cities",
    "paint": {
        "fill-color": "#232C60",
        "fill-opacity": 0.1,
    }
};
export const cityHover = {
    "id": "cityHover",
    "type": "fill",
    "source": "cities",
    "paint": {
        "fill-color": "#232C60",
        "fill-opacity": 1,
    }
};
export const clusterLayer = {
    id: 'clusters',
    type: 'symbol',
    source: 'resources',
    // filter: ['has', 'point_count'],
    paint: {
        'text-color': '#ffffff',
    },
    layout: {
        'symbol-z-order': 'viewport-y',
        'icon-image': 'map-pin',
        'icon-anchor': 'bottom',
        'icon-overlap': 'always',
        'icon-size': [
            "interpolate",
            ["linear"],
            ["zoom"],
            8, 0.25,
            12, 0.9
        ],
        'text-field': '{point_count_abbreviated}',
        'text-font': ['DIN Offc Pro Bold', 'Arial Unicode MS Bold'],
        'text-size': 12,
        'text-offset': [0, -1.75],
        'text-allow-overlap': true,
    }
};
export const unclusteredPointLayer = {
    id: 'unclusteredPoints',
    type: 'symbol',
    source: 'resources',
    filter: ['!', ['has', 'point_count']],
    layout: {
        'symbol-z-order': 'viewport-y',
        'icon-image': 'map-pin',
        'icon-overlap': 'always',
        'icon-size': [
            "interpolate",
            ["linear"],
            ["zoom"],
            8, 0.25,
            12, 0.8
        ],
        'icon-anchor': 'bottom',
    }
};
export const allPointLayer = {
    id: 'allPoints',
    type: 'symbol',
    source: 'resources',
    filter: ['!', ['has', 'point_count']],
    layout: {
        'symbol-z-order': 'viewport-y',
        'icon-image': 'map-pin',
        'icon-size': 0.1,
        'icon-anchor': 'bottom',
    }
};
